import { ActionType, getType } from 'typesafe-actions';

import { LegFlow } from '../../../../../../models/LegFlow';

import { PricerActionType } from '../../pricerReducer';

import * as flowsActions from './actions';

export type FlowsActionType = ActionType<typeof flowsActions>;

export type FlowsState = LegFlow[];

export const ValuationInitialState: FlowsState = [];

const FlowsReducer = (
  state: FlowsState = ValuationInitialState,
  action: PricerActionType | FlowsActionType,
): FlowsState => {
  switch (action.type) {
    case getType(flowsActions.updateFlowTableByCellEdit): {
      const newData = [...state];
      newData[action.payload.rowId] = {
        ...newData[action.payload.rowId],
        ...action.payload.row,
      };

      return [...newData];
    }

    case getType(flowsActions.deleteFlowRows): {
      return [
        ...state.filter(
          (flow, index) => action.payload.rowIds.indexOf(index) === -1,
        ),
      ];
    }

    default:
      return state;
  }
};

export default FlowsReducer;
